import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import displayNames from '../../controls/displayNames';

var PanelFooter = /*#__PURE__*/function (_React$Component) {
  _inherits(PanelFooter, _React$Component);

  var _super = _createSuper(PanelFooter);

  function PanelFooter() {
    _classCallCheck(this, PanelFooter);

    return _super.apply(this, arguments);
  }

  _createClass(PanelFooter, [{
    key: "render",
    value: function render() {
      var ActionBtnSymbol = this.props.actionBtnSymbol;
      var Thumbnails = this.props.thumbnails;
      return /*#__PURE__*/React.createElement("footer", {
        "data-aid": this.props.automationId,
        "data-hook": this.props.dataHook,
        className: this.props.getClassName('panel-footer'),
        style: this.props.style
      }, ActionBtnSymbol ? /*#__PURE__*/React.createElement(ActionBtnSymbol, null) : null, /*#__PURE__*/React.createElement("div", {
        className: "panel-footer-action-btn"
      }, this.props.actionBtn), Thumbnails ? /*#__PURE__*/React.createElement(Thumbnails, null) : null);
    }
  }]);

  return PanelFooter;
}(React.Component);

PanelFooter.displayName = displayNames.PANEL_FOOTER;
PanelFooter.propTypes = {
  actionBtn: PropTypes.element,
  onActionBtn: PropTypes.func,
  noActionBtn: PropTypes.bool,
  actionButtonSymbol: PropTypes.element,
  thumbnails: PropTypes.element
};
PanelFooter.defaultProps = {
  dataHook: 'panel-footer'
};
export default compose(PanelFooter);